// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogPaginate_wrapper__iewFp","link":"BlogPaginate_link__kCxvi","current":"BlogPaginate_current__Hvz_L"};